import SectionHeader from 'components/UI/SectionHeader'
import { API_URL_ADMIN_PARAMETERS } from 'constants/api'
import { useI18n } from 'context/I18nProvider'
import useSWR from 'hooks/swr'
import { useNavigate, useRouteLoaderData } from 'react-router-dom'
import type { Settings } from 'shared/types'

const BottomMessagePage = () => {
  const { i18n } = useI18n()
  const settings = useRouteLoaderData('root') as Settings
  const navigate = useNavigate()

  const { data: settingsData } = useSWR(`${API_URL_ADMIN_PARAMETERS}?paginated=false`)
  const customerName = settingsData?.customerName
  const intro = i18n('infoMessage.intro').replace('{ customerName }', customerName || '')
  const title = i18n('infoMessage.title').replace('{ customerName }', customerName || '')

  return (
    <>
      <SectionHeader title={title} buttonLabel={i18n('label.back')} buttonProps={{ onClick: () => navigate(-1) }} />
      <div className="text-gray-600">{intro}</div>
      <div className="my-6 border-t border-gray-600" />
      <div className="mx-auto mt-6">
        {settings.bottomMessage ? (
          <div
            className="[&_h1]:my-4 [&_h1]:text-3xl [&_h1]:font-bold [&_h2]:my-4 [&_h2]:text-2xl [&_h2]:font-bold [&_h3]:my-3 [&_h3]:text-xl [&_h3]:font-bold [&_h4]:my-3 [&_h4]:text-lg [&_h4]:font-bold [&_p]:my-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:list-disc [&_ul]:pl-6 [&_blockquote]:my-4 [&_blockquote]:border-l-4 [&_blockquote]:border-slate-300 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:text-slate-600 [&_pre]:my-4 [&_pre]:overflow-x-auto [&_pre]:rounded-xxs [&_pre]:bg-slate-100 [&_pre]:p-4 [&_pre]:font-mono [&_pre]:text-sm [&_code]:rounded-xxs [&_code]:bg-slate-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-sm [&_pre_code]:bg-transparent [&_pre_code]:p-0"
            dangerouslySetInnerHTML={{ __html: settings.bottomMessage }}
          />
        ) : (
          <div className="text-gray-500">{i18n('infoMessage.noMessage')}</div>
        )}
      </div>
    </>
  )
}

export default BottomMessagePage
